export const BACKEND_ENDPOINT = 'https://ly9szfvah3.execute-api.eu-central-1.amazonaws.com/prod/functions'
export const BACKEND_USER_ENDPOINT = ' https://ly9szfvah3.execute-api.eu-central-1.amazonaws.com/prod/user'
export const GET_FUNCTIONS_BY_USER_ENDPOINT = BACKEND_ENDPOINT + "/getFunctionsList"
export const QUERY_STALE_TIME = 5 * 60 * 1000
export const SIGNATURE_TIME_OUT = 86_400// days
export const MIN_CREDIT_AMOUNT_FOR_CREATING_FUNCTION = 10
export const MAX_FILE_SIZE = 1048576 * 5; // 5MB in bytes
export const MAX_FUNCTIONS_PER_USER = 5